var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import { Box, CircularProgress, makeStyles } from "@material-ui/core";
export default (_a) => {
    var { color, timeout = 5000, timeoutMessage = [
        "Пожалуйста, подождите",
        "Похоже, что это действие требует много времени",
        "Еще немного...",
        "Почти готово...",
    ] } = _a, boxProps = __rest(_a, ["color", "timeout", "timeoutMessage"]);
    const classes = useStyles({ color });
    const [currentTimeoutMessage, setCurrentTimeoutMessage] = useState(0);
    useEffect(() => {
        setTimeout(() => {
            if ((Array.isArray(timeoutMessage) &&
                timeoutMessage.length >= currentTimeoutMessage + 1) ||
                currentTimeoutMessage === 0) {
                setCurrentTimeoutMessage((currentTimeoutMessage) => currentTimeoutMessage + 1);
            }
        }, timeout);
    }, [currentTimeoutMessage]);
    return (React.createElement(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center" }, boxProps),
        React.createElement("div", { className: classes.progressWrapper },
            React.createElement(CircularProgress, { className: classes.progress }),
            React.createElement("div", { className: classes.tooltip }, currentTimeoutMessage
                ? Array.isArray(timeoutMessage)
                    ? timeoutMessage[currentTimeoutMessage - 1]
                    : timeoutMessage
                : null))));
};
const useStyles = makeStyles((theme) => ({
    progressWrapper: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "200px",
        textAlign: "center",
    },
    progress: ({ color = "dark" }) => ({
        color: color !== "inherit" ? theme.palette.loader[color] : "inherit",
        marginBottom: 16,
    }),
    tooltip: ({ color = "dark" }) => ({
        position: "absolute",
        top: "100%",
        color: color !== "inherit" ? theme.palette.loader[color] : "inherit",
    }),
}));
//# sourceMappingURL=FTLLoader.js.map